"use strict";
/**
 * @copyright 2020 Microsoft Corporation
 */
var $dyn;
(function ($dyn) {
    /**
     * A replacement for the native browser tooltip using the QTip framework that allows for rich formatting
     * and much more customization.
     * @internal
     */
    var superTooltip;
    (function (superTooltip) {
        superTooltip._closeSuperTooltipInterval = -1;
        superTooltip._superToolTipStorage = "data-dyn-qtip-title";
        superTooltip._superToolTipStorageDescribedBy = "data-dyn-qtip-describedby";
        superTooltip._superToolTipControl = null;
        /**
         * Destroys any open superToolTip and clears our global control holder.
         * @internal
         */
        function destroySuperTooltip() {
            if ($dyn.superTooltip.superToolTip) {
                var tipElement = void 0;
                if ($dyn.superTooltip.superToolTip.elements && $dyn.superTooltip.superToolTip.elements.target[0]) {
                    tipElement = $dyn.superTooltip.superToolTip.elements.target[0];
                }
                $dyn.superTooltip.clearPreviewCloseInterval();
                $dyn.superTooltip.superToolTip.destroy(true);
                $dyn.superTooltip.superToolTip = null;
                $dyn.superTooltip._superToolTipControl = null;
                if (tipElement) {
                    $dyn.superTooltip.restoreElementAttributes(tipElement);
                }
            }
        }
        superTooltip.destroySuperTooltip = destroySuperTooltip;
        /**
         * restores attributes to element
         * @internal
         * @param element The DOM element to use for analysis.
         */
        function restoreElementAttributes(element) {
            if (element) {
                var timeoutWait = $dyn.flags.disableAnimations ? 0 : 250;
                setTimeout(function () {
                    if (element.getAttribute($dyn.superTooltip._superToolTipStorage)) {
                        var tempTitle = element.getAttribute($dyn.superTooltip._superToolTipStorage);
                        element.setAttribute("title", tempTitle);
                        element.removeAttribute($dyn.superTooltip._superToolTipStorage);
                    }
                    if (element.getAttribute($dyn.superTooltip._superToolTipStorageDescribedBy)) {
                        var tempDescribeBy = element.getAttribute($dyn.superTooltip._superToolTipStorageDescribedBy);
                        if (tempDescribeBy !== "null") {
                            element.setAttribute("aria-describedby", tempDescribeBy);
                        }
                        else {
                            element.removeAttribute("aria-describedby");
                        }
                        element.removeAttribute($dyn.superTooltip._superToolTipStorageDescribedBy);
                    }
                }, timeoutWait); // this timeout is to ensure that qtip has removed the element before we put back the describedby
            }
        }
        superTooltip.restoreElementAttributes = restoreElementAttributes;
        /**
         * Returns the correct title to use for the superToolTip based on element of control values.
         * @internal
         *
         * @param element The DOM element to use for analysis.
         * @returns The title value.
         */
        function getTitle(element) {
            var titleText;
            var attributeText;
            var control = $dyn.ui.getLiveControl(element);
            // Need to grab the label if we are using the react grid because the title will already have the helptext concatenated
            if (control && control.isInGrid && control.isInGrid() && control.Root && control.Root.UseReactGrid()) {
                titleText = $dyn.value(control.Label);
                return titleText;
            }
            // Grab title
            if (element) {
                if (element.title) {
                    // grab title if it is directly on the element
                    titleText = element.title;
                }
                else {
                    // in special cases you may set the attribute , good for when you change the title while tooltip is open
                    attributeText = element.getAttribute("data-dyn-title");
                    if (attributeText) {
                        titleText = attributeText;
                    }
                    else {
                        // check if attribute is set (reserved typically for items that update the tooltip while showing it (React))
                        if (control) {
                            // first grab the label - however some controls have no label and instead have Title - so grab that instead
                            if ($dyn.value(control.Label)) {
                                titleText = element.getAttribute("dyn-data-optional-label") ? element.getAttribute("dyn-data-optional-label") : $dyn.value(control.Label);
                            }
                            else if ($dyn.value(control.Title)) {
                                titleText = $dyn.value(control.Title);
                            }
                        }
                    }
                }
            }
            return titleText;
        }
        superTooltip.getTitle = getTitle;
        /**
         * Returns the correct body text to use for the superToolTip based on element of control values.
         * @internal
         * @param element The dom element to use for analysis.
         * @returns The body text value.
         */
        function getBody(element) {
            var bodyText;
            var attributeText;
            // Grab help text
            if (element) {
                attributeText = element.getAttribute("data-dyn-helptext");
                if (attributeText) {
                    bodyText = attributeText;
                }
                else {
                    var control = $dyn.ui.getLiveControl(element);
                    if (control && $dyn.value(control.HelpText) && !control.hideTooltipBody) {
                        bodyText = $dyn.value(control.HelpText) ? $dyn.value(control.HelpText) : null;
                    }
                }
            }
            return bodyText;
        }
        superTooltip.getBody = getBody;
        /**
         * Returns if the passed in element is in a grid or if it is a grid header.
         * @internal
         * @param element The dom element to use for analysis.
         * @returns Flag if in a grid and not the header.
         */
        function isElementInGrid(element) {
            // first check if we are in a grid - if so grab real control not virtual
            if (element.isInGrid === undefined) {
                var control = $dyn.ui.getLiveControl(element);
                if (control === undefined) {
                    return false;
                }
                if (control.isInGrid && control.isInGrid() && control.TypeName !== "ColumnHeader" && !$(element.parentElement).hasClass("dyn-headerCell")) {
                    return true;
                }
            }
            else {
                return element.isInGrid();
            }
            return false;
        }
        superTooltip.isElementInGrid = isElementInGrid;
        /**
         * Will gather data from dom to send to superTooltip generator.
         * @internal
         *
         * @param element The dom element to use.
         * @param titleParameter The title to pass in to open a tooltip (optional).
         * @param bodyParameter The body text to pass in to open a tooltip (optional).
         */
        function tryOpenSuperTooltip(element, titleParameter, bodyParameter) {
            var defaultClasses = "baseDirection fieldToolTipBase";
            // dont show superTooltip if in a grid and not the header
            if ($dyn.superTooltip.isElementInGrid(element)) {
                return;
            }
            // check if element already has a qtip - abort
            if ($(element).data("qtip")) {
                return;
            }
            var titleText = titleParameter === undefined ? $dyn.superTooltip.getTitle(element) : titleParameter;
            var bodyText = bodyParameter === undefined ? $dyn.superTooltip.getBody(element) : bodyParameter;
            // if no help text add a hide class for the qtip styles (hides content.text)
            if (!bodyText) {
                defaultClasses = defaultClasses + " bodyTextHide";
            }
            if (titleText) {
                // is a tip already open - destroy it as we are in a nested element (not supported)
                if ($dyn.superTooltip.superToolTip) {
                    $dyn.superTooltip.destroySuperTooltip();
                }
                // save off control for cleanup later
                $dyn.superTooltip._superToolTipControl = element;
                if (element.getAttribute("title")) {
                    element.setAttribute(superTooltip._superToolTipStorage, titleText);
                    element.setAttribute(superTooltip._superToolTipStorageDescribedBy, element.getAttribute("aria-describedby"));
                    element.removeAttribute("title");
                    element.removeAttribute("aria-describedby");
                }
                try {
                    // tslint:disable:object-literal-sort-keys
                    $dyn.superTooltip.superToolTip = $(element).qtip({
                        id: "superToolTip",
                        overwrite: false,
                        suppress: false,
                        content: {
                            text: $("<div>").text(bodyText),
                            title: $("<div>").text(titleText)
                        },
                        style: {
                            classes: defaultClasses,
                            tip: false
                        },
                        position: {
                            my: "bottom center",
                            at: "top center",
                            viewport: $(window),
                            effect: $dyn.flags.disableAnimations ? false : undefined,
                        },
                        show: {
                            delay: $dyn.flags.disableAnimations ? 0 : 500,
                            ready: true,
                            effect: $dyn.flags.disableAnimations ? false : undefined,
                        },
                        hide: {
                            fixed: true,
                            event: "click mouseleave blur",
                            effect: $dyn.flags.disableAnimations ? false : undefined,
                        },
                        events: {
                            render: function (event, api) {
                                var elem = $("[id=qtip-superToolTip]")[0];
                                $(elem).attr("role", "tooltip");
                                // remove aria-atomic as that causes divs to be announced
                                $(elem).find(".qtip-content").removeAttr("aria-atomic");
                                $(elem).find(".qtip-title").removeAttr("aria-atomic");
                                $(elem).find(".qtip-titlebar").removeAttr("aria-atomic");
                                // register keydown
                                $(document.body).on("keydown.superToolTipEsc", function (keyBoardEvent) {
                                    if (keyBoardEvent.keyCode === $dyn.ui.KeyCodes.esc) {
                                        keyBoardEvent.stopPropagation();
                                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Escape handler for superToolTipEsc");
                                        keyBoardEvent.preventDefault();
                                        api.hide();
                                    }
                                });
                            },
                            focus: function (event, api) {
                                event.preventDefault(); // prevents other qtips from dismissing
                            },
                            hide: function (event, api) {
                                $dyn.superTooltip.destroySuperTooltip();
                                $(document.body).off("keydown.superToolTipEsc");
                            },
                        }
                    }).qtip("api");
                    // tslint:enable:object-literal-sort-keys
                    superTooltip._closeSuperTooltipInterval = window.setInterval($dyn.superTooltip.checkSuperTooltipClose, 500);
                }
                catch (error) {
                    $dyn.telemetry.addErrorEvent({ errorLabel: "Supertooltip", callStack: error.stack, type: 3 });
                    // put title back
                    if (element) {
                        $dyn.superTooltip.restoreElementAttributes(element);
                    }
                }
            }
        }
        superTooltip.tryOpenSuperTooltip = tryOpenSuperTooltip;
        /**
         * Based on a timer value will check if a superTooltips element has moved
         * @internal
         */
        function checkSuperTooltipClose() {
            var element = $dyn.superTooltip._superToolTipControl;
            // check to see if the host control has moved
            if (!$.contains(document.body, element)) {
                $dyn.superTooltip.clearPreviewCloseInterval();
                $dyn.superTooltip.destroySuperTooltip();
            }
        }
        superTooltip.checkSuperTooltipClose = checkSuperTooltipClose;
        /**
         * Clears out the timer for checking superToolTip closing
         * @internal
         */
        function clearPreviewCloseInterval() {
            // stop polling
            if (superTooltip._closeSuperTooltipInterval !== -1) {
                window.clearInterval(superTooltip._closeSuperTooltipInterval);
                superTooltip._closeSuperTooltipInterval = -1;
            }
        }
        superTooltip.clearPreviewCloseInterval = clearPreviewCloseInterval;
    })(superTooltip = $dyn.superTooltip || ($dyn.superTooltip = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=SuperToolTip.js.map
